import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
